export enum HowQuicklyImportType {
    Now,
    Within2Weeks,
    Plus3Weeks,
    NotSure
}



// WEBPACK FOOTER //
// ./app/objects/orders/how-quickly-import-type.ts